<template>
  <div class="w-100 carousel-main-height-wrapper">
    <div class="container-fluid">
      <div class="row align-items-center mb-2">
        <div class="col-12 col-lg-8 text-left px-0">
          <div
            class="w-100 d-flex align-items-end justify-content-between justify-content-lg-start"
          >
            <span class="rails-header-title">Trending</span>
          </div>
        </div>
      </div>
      <div
        class="row mr-0 mr-lg-up latest-popular-v2-rails-content"
        id="popularVODHomepagev2"
      >
        <div class="owl-carousel owl-theme" id="populartvhomepagecarousel">
          <div
            class="item"
            v-for="(item_vod, idx) in popular_list"
            :key="item_vod.id"
            @mouseover="mouseOver"
            @mouseout="mouseOver"
          >
            <popularCard
              :order="idx + 1"
              :image="item_vod.img_link"
              :title="item_vod.longTitle"
              :link="item_vod.redirect_url"
              :index="idx"
              :data="item_vod.data"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import popularCard from "../../../cards/v2/popularCard.vue";
import ChevronRight from "../../../../assets/rtmklik/svg/theme_chevron_right.svg";
import ChevronLeft from "../../../../assets/rtmklik/svg/theme_chevron_left.svg";
import noImage from "../../../../assets/noimage.png";
export default {
  data: function() {
    return {
      popular_list: [],
      hover: false,
      totalItem: 6,
    };
  },
  components: { popularCard },
  created: function() {
    this.$store.dispatch("fetchPopularList", { self: this });
  },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },
    filterPopularList() {
      //for latest video
      var vm = this;
      vm.popular_list = this.$store.state.popular_list.data;
      var store = [];
      vm.popular_list.forEach((item) => {
        var redirectLink = this.getAssetLink(item);
        item["img_link"] = item.data.images
          ? this.rtmImgLinkFiltering(item.data.images, "220x300", "poster")
          : noImage;
        item["redirect_url"] = redirectLink;
        store.push(item);
      });

      vm.popular_list = store.slice(0, 10);

      Vue.nextTick(
        function() {
          vm.installOwlCarousel("#populartvhomepagecarousel");
        }.bind(vm)
      );
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 6,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [`<img src=${ChevronLeft} />`, `<img src=${ChevronRight} />`],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 0,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 8,
            nav: false,
          },
          992: {
            items: 5,
            stagePadding: 0,
            loop: false,
            margin: 6,
            nav: true,
          },
          1280: {
            items: 6,
            stagePadding: 2,
            loop: false,
            margin: 8,
            nav: true,
          },
        },
      });
    },

    formatString(str) {
      var lower = str.toLowerCase();
      return lower
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
};
</script>
<style>
.latest-popular-v2-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}
#popularVODHomepagev2 .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  /* #popularVODHomepagev2 .owl-stage:hover {
    display: flex;
    flex-wrap: nowrap;
  } */

  #popularVODHomepagev2 .owl-theme:hover {
    z-index: 111;
  }

  #popularVODHomepagev2 .owl-theme {
    height: auto;
  }
  #popularVODHomepagev2 .owl-item {
    z-index: 1;
    /* min-height: 100px;
    max-height: calc(300 / 478 * 100%);
    cursor: pointer; */
  }
  #popularVODHomepagev2 .owl-item .item {
    width: 100%;
    height: 100%;
  }
  #popularVODHomepagev2 .owl-item:hover {
    transform: scale(1.1);
    /* transition: width 0.3s ease-in-out; */
    z-index: 2000;
    /* width: calc((300 / 448 * 100%) / 3.02) !important; */
  }

  #popularVODHomepagev2 .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #popularVODHomepagev2 .owl-theme .owl-nav {
    position: absolute;
    top: -48px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
  }

  #popularVODHomepagev2 .owl-prev img {
    width: 22px;
    height: 23px;
  }

  #popularVODHomepagev2 .owl-next img {
    width: 22px;
    height: 23px;
  }
}
</style>
